// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

import templateHome from './routes/templateHome';
import templateTeam from './routes/templateTeam';

/** Populate Router instance with DOM routes */
const routes = new Router({
  common,
  templateHome,
  templateTeam,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js